module.exports = __webpack_public_path__ + "static/media/signage-industrial-img4.6b25d33f.jpg";